import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Menu,
  useMediaQuery,
  useTheme,
  Select,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";

import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import BusinessDialog from "./BusinessDialog";
import { getKeysAndValues } from "../../../utils/getKeysAndValues";
import StatusAlert from "../../../StatusAlertList/StatusAlert";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { BusinessSettingsApi } from "../../../Data/axios";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function BusinessSettings() {
  const [open, setOpen] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageValue, setPageValue] = useState(1);
  const [rowCountValue, setRowCountValue] = useState(0);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [update, setUpdate] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState({
    keys: [],
    values: [],
    open: false,
  });

  const handleClickUpdate = () => {
    setUpdate(true);
  };

  const handleUpdateClose = () => {
    setUpdate(false);
  };
  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const handleViewMore = () => {
    const rowData = businesslocation.filter((row) => row.id === openMenuId);

    const { keys, values } = getKeysAndValues(rowData[0]);

    setSelectedRow({ keys, values, open: true });
    // setOpenDialog(true);
  };
  const handleDailogClosing = () => {
    setSelectedRow({ ...selectedRow, open: false });
  };

  const handleGenderChange = (event) => {
    setType(event.target.value);
  };
  const handleTypeUpdate = (event) => {
    setUpdateType(event.target.value);
  };
  const handleType = (event) => {
    setType(event.target.value);
  };
  const OfficeType = ["office", "warehouse", "retail"];

  // Function Starts Here

  const [location, setLocation] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [manager, setManager] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [officecode, setOfficecode] = useState("");
  const [details, setDetails] = useState("");
  const [updatetype, setUpdateType] = useState("");
  const [updatelocation, setUpdateLocation] = useState("");
  const [updateaddress, setUpdateAddress] = useState("");
  const [updatecountry, setUpdateCountry] = useState("");
  const [updatemanager, setUpdateManager] = useState("");
  const [updatephone, setUpdatePhone] = useState("");
  const [updateemail, setUpdateEmail] = useState("");
  const [updateofficecode, setUpdateOfficecode] = useState("");
  const [updatedetails, setUpdateDetails] = useState("");

  const [data, setData] = useState([]);

  const StatusOptions = ["Active", "Inactive"];
  const [openMenuId, setOpenMenuId] = useState(null);

  const item = {
    location,
    address,
    country,
    manager,
    phone,
    email,
    officecode,
    details,
    type,
  };
  // const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      setError("Email is required");
    } else if (!emailRegex.test(value)) {
      setError("Please enter a valid email address");
    } else {
      setError("");
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    validateEmail(value); // Validate on change (optional)
  };

  const handleEmailBlur = () => {
    validateEmail(email); // Validate on blur
  };
  const [errorNumber, setErrorNumber] = useState("");

  const validatePhoneNumber = (value) => {
    const phoneRegex = /^\+?[1-9]\d{1,14}$/; // E.164 format: +countryCode phoneNumber
    if (!value) {
      setErrorNumber("Manager number is required");
    } else if (!phoneRegex.test(value)) {
      setErrorNumber("Please enter a valid phone number (e.g., +911234567890)");
    } else {
      setErrorNumber("");
    }
  };

  const handlePhoneChange = (e) => {
    const newValue = e.target.value;
    setPhone(newValue);
    validatePhoneNumber(newValue); // Optional: Validate while typing
  };
  const clearAllData = () => {
    setLocation("");
    setAddress("");
    setCountry("");
    setManager("");
    setPhone("");
    setEmail("");
    setOfficecode("");
    setDetails("");
    setType("");
  };
  const handlePhoneBlur = () => {
    validatePhoneNumber(phone); // Validate on blur
  };
  async function SaveDate() {
    try {
      const formData = new FormData();

      for (const key in item) {
        if (item[key] !== undefined && item[key] !== null) {
          formData.append(key, item[key]);
        }
      }
      await BusinessSettingsApi.add(formData);
      showAlert("Business location Added successfully", "success");
      getData();
      clearAllData();
      setOpen(false);
    } catch (error) {
      showAlert("Failed to add!!", "warning");
    }
  }

  const [businesslocation, setBusinesslocation] = useState([]);

  useEffect(() => {
    getData();
  }, [rowsPerPage, pageValue]);

  async function getData() {
    const response = await BusinessSettingsApi.getAll(pageValue, rowsPerPage);

    setBusinesslocation(response?.data);
    setRowsPerPage(response?.per_page);
    setRowCountValue(response?.total);
  }
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const columns = [
    {
      name: "officecode",
      label: "Office Code",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Office Code
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },
    {
      name: "location",
      label: "Location",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Location
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "address",
      label: "Address",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Address
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "manager",
      label: "Manager",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Manager
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "phone",
      label: "Phone",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Phone
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Email
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "70px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <>
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns content to the left
                alignItems: "center",
                paddingRight: "20px", // Add padding for starting point
              }}
            >
              <div style={{ paddingRight: "20px" }}>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleViewMore(tableMeta.rowData)}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <RemoveRedEyeIcon /> View More
                    </div>
                  </MenuItem>

                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleEdit()}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <EditNoteIcon /> Edit
                    </div>
                  </MenuItem>

                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleDelete(value)}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <DeleteForeverIcon /> Delete
                    </div>
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </>
        ),
      },
    },
  ];

  async function handleEdit() {
    const result = await BusinessSettingsApi.edit(openMenuId);

    setData(result);
    handleClickUpdate();
  }

  useEffect(() => {
    setUpdateOfficecode(data.officecode);
  }, [data.officecode]);

  useEffect(() => {
    setUpdateCountry(data.country);
  }, [data.country]);

  useEffect(() => {
    setUpdateLocation(data.location);
  }, [data.location]);

  useEffect(() => {
    setUpdateManager(data.manager);
  }, [data.manager]);

  useEffect(() => {
    setUpdatePhone(data.phone);
  }, [data.phone]);

  useEffect(() => {
    setUpdateEmail(data.email);
  }, [data.email]);

  useEffect(() => {
    setUpdateAddress(data.address);
  }, [data.address]);

  useEffect(() => {
    setUpdateType(data.type);
  }, [data.type]);

  useEffect(() => {
    setUpdateDetails(data.details);
  }, [data.details]);

  useEffect(() => {
    setStatus(data.status);
  }, [data.status]);
  const clearUpdateData = () => {
    setUpdateLocation("");
    setUpdateAddress("");
    setUpdateCountry("");
    setUpdateManager("");
    setUpdatePhone("");
    setUpdateEmail("");
    setUpdateOfficecode("");
    setUpdateDetails("");
    setUpdateType("");
  };
  async function UpdateData() {
    const formData = new FormData();
    formData.append("officecode", updateofficecode);
    formData.append("country", updatecountry);
    formData.append("location", updatelocation);
    formData.append("address", updateaddress);
    formData.append("manager", updatemanager);
    formData.append("phone", updatephone);
    formData.append("email", updateemail);
    formData.append("type", updatetype);
    formData.append("details", updatedetails);
    formData.append("status", status);

    try {
      await BusinessSettingsApi.update(data.id, formData);
      showAlert("Business location updated successfully", "success");
      handleUpdateClose();
      getData();
      clearUpdateData();
    } catch (error) {
      console.error(error);
      showAlert("Failed to update business location", "error");
    }
  }

  async function handleDelete() {
    await BusinessSettingsApi.delete(openMenuId);
    getData();
    showAlert("Business location Deleted successfully", "warning");
  }

  // end delete

  const rowsPerPageOptions = [5, 10, 25, 100];
  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
      setPageValue(0);
    },
    totalPages: Math.ceil(rowCountValue / rowsPerPage),
    onChangePage: (currentPage) => {
      setPageValue(currentPage + 1);
    },
    customFooter: (
      rowCount,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage
    ) => {
      const totalPages = Math.ceil(rowCountValue / rowsPerPage);

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div>
            <span>
              Showing {page * rowsPerPage + 1} -{" "}
              {Math.min(rowCountValue, (page + 1) * rowsPerPage)} of{" "}
              {rowCountValue} entries
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <label htmlFor="rowsPerPage">Rows per page: </label>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => changeRowsPerPage(Number(e.target.value))}
              >
                {rowsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ padding: "10px", textAlign: "right" }}>
              Page {page + 1} of {totalPages}
              <Button
                variant="outlined"
                onClick={() => changePage(page - 1)}
                disabled={page === 0}
                sx={{
                  margin: "0 5px",
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Previous
              </Button>
              <Button
                variant="outlined"
                onClick={() => changePage(page + 1)}
                disabled={page + 1 === totalPages}
                sx={{
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      );
    },
    tableBody: {
      style: {
        maxHeight: `${rowsPerPage * 50}px`,
        overflow: "auto",
        marginLeft: "5px",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        boxShadow: "none",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {},
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          // maxWidth: "1000px",
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  // Table Ends Here
  const theme = useTheme();
  const isBelow500px = useMediaQuery(theme.breakpoints.down("500"));
  return (
    <>
      <BusinessDialog
        open={selectedRow.open}
        handleClose={handleDailogClosing}
        rowData={selectedRow}
      />
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />

      <Box>
        <Dialog
          fullWidth
          maxWidth="md"
          open={update}
          onClose={handleUpdateClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              position: "absolute",
              background: "#141b2d",
              top: "0",
              backgroundColor: "white",
              maxHeight: "95%",
              margin: "auto",
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateClose}
                aria-label="close"
              >
                <CloseIcon fontSize="large" />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, fontSize: "18px" }}
                component="div"
              >
                Update Business Location
              </Typography>
            </Toolbar>
          </AppBar>

          <Box>
            <Grid
              container
              spacing={2}
              style={{ color: "black", margin: "10px" }}
            >
              <Grid item xs={11} sm={3}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Office Code
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="RPTPL001"
                      value={updateofficecode}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdateOfficecode(newValue);
                      }}
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{
                        style: {
                          color: "black",
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={11} sm={4}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Country
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="India"
                        value={updatecountry}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setUpdateCountry(newValue);
                        }}
                        inputProps={{
                          style: {
                            color: "black",
                            border: "1px solid black",
                            borderRadius: "5px",
                          },
                        }}
                        InputLabelProps={{ style: { color: "black" } }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderColor: "black",
                            "&:hover fieldset": {
                              borderColor: "black",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black",
                            },
                          },
                          "& .MuiOutlinedInput-input": {
                            "&::placeholder": { color: "gray" },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={11} sm={4}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Location
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={8}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Lucknow"
                      type="email"
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      value={updatelocation}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdateLocation(newValue);
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              style={{ color: "black", margin: "10px" }}
            >
              <Grid item xs={11} sm={3.5}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Manager Name
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Name"
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      value={updatemanager}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdateManager(newValue);
                      }}
                      sx={{
                        marginTop: "5px",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={11} sm={3.5}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Manager Number
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="+91 123456789"
                      type="email"
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      value={updatephone}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdatePhone(newValue);
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={11} sm={4}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Manager email
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="manager@gmail.com"
                      type="email"
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      value={updateemail}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdateEmail(newValue);
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              style={{ color: "black", margin: "10px" }}
            >
              <Grid item xs={11} sm={8}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Address
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="e.g.Address"
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      value={updateaddress}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdateAddress(newValue);
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={11} sm={3}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Status
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      select
                      value={status === 1 ? "Active" : "Inactive"} // Set the value based on status
                      fullWidth
                      style={{ border: "1px solid black", borderRadius: "5px" }}
                      placeholder="Status"
                      onChange={(e) => {
                        const value = e.target.value;
                        const statusValue = value === "Active" ? 1 : 0;
                        setStatus(statusValue);
                      }}
                      inputProps={{
                        style: {
                          color: "black",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      sx={{
                        "& .MuiSelect-root": {
                          color: "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                          color: "black",
                        },
                      }}
                    >
                      {StatusOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              style={{ color: "black", margin: "10px" }}
            >
              <Grid item xs={12} sm={4} md={3}>
                <Stack direction="column">
                  <Typography
                    variant="p"
                    gutterBottom
                    style={{ color: "black" }}
                  >
                    Office type
                  </Typography>
                  <Select
                    value={updatetype}
                    autoFocus
                    onChange={handleTypeUpdate}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{
                      border: "1px solid black",
                      boxSizing: "border-box",
                      "& .MuiOutlinedInput-root": {
                        borderColor: "black !important",
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      color: "black",
                    }}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span style={{ color: "gray" }}>
                            Select office type
                          </span>
                        );
                      }
                      return selected;
                    }}
                  >
                    {OfficeType.map((item) => (
                      <MenuItem value={item} key={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </Stack>
              </Grid>
              <Grid item xs={11} sm={7}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Details
                </Typography>
                <Grid container spacing={4} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Rent,Contact date"
                      type="email"
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      value={updatedetails}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdateDetails(newValue);
                      }}
                      sx={{
                        marginTop: "5px",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "10px 0 20px 20px" }}>
              <Grid item sx={11} className="messageFooter">
                <Box className="response" onClick={UpdateData}>
                  Update
                </Box>
                <Box className="cancel" onClick={handleUpdateClose}>
                  Cancel
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Dialog>
      </Box>

      <List
        style={{
          background: "none",
          padding: 5,
        }}
      >
        <ListItemText
          style={{ background: "none", margin: "5px 0", zIndex: 13000 }}
        >
          <React.Fragment>
            <StatusAlert
              open={alertOpen}
              setOpen={setAlertOpen}
              message={alertMessage}
              severity={alertSeverity}
            />
            <Box
              onClick={handleClickOpen}
              sx={{
                backgroundColor: "#1d82f5",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                padding: "10px",
                height: "40px",
                width: "210px",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                borderRadius: "4px",
                fontSize: "15px",
                fontFamily: "sans-serif",
                cursor: "pointer",
              }}
            >
              <AddCircleIcon /> Add Business Locations
            </Box>
            <Dialog
              fullWidth
              maxWidth="md"
              open={open}
              onClose={handleClose}
              TransitionComponent={Transition}
              PaperProps={{
                style: {
                  position: "absolute",
                  background: "#141b2d",
                  top: "0",
                  backgroundColor: "white",
                  maxHeight: "95%",
                  margin: "auto",
                  overflowX: "hidden",
                  zIndex: 1200,
                },
              }}
            >
              <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                  >
                    <CloseIcon fontSize="large" />
                  </IconButton>
                  <Typography
                    sx={{ ml: 2, flex: 1, fontSize: "18px" }}
                    component="div"
                  >
                    Add Business Location
                  </Typography>
                </Toolbar>
              </AppBar>
              <Box>
                <Grid
                  container
                  spacing={2}
                  style={{ color: "black", margin: "10px", zIndex: 13000 }}
                >
                  <Grid item xs={11} sm={3.5}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Office Code
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          variant="outlined"
                          required
                          fullWidth
                          placeholder="RPTPL001"
                          onChange={(e) => setOfficecode(e.target.value)}
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={11} sm={3.5}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Country
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          fullWidth
                          placeholder="India"
                          onChange={(e) => setCountry(e.target.value)}
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={11} sm={4}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Location
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          fullWidth
                          placeholder="Lucknow"
                          type="email"
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          onChange={(e) => setLocation(e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  style={{ color: "black", margin: "10px" }}
                >
                  <Grid item xs={11} sm={4}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Manager Name
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          fullWidth
                          placeholder="Name"
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          onChange={(e) => setManager(e.target.value)}
                          sx={{
                            marginTop: "5px",
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={11} sm={3.5}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Manager Number
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          placeholder="+91 1234567890"
                          type="tel"
                          value={phone}
                          onChange={handlePhoneChange}
                          onBlur={handlePhoneBlur}
                          error={!!errorNumber}
                          helperText={errorNumber}
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errorNumber ? "red" : "black",
                              },
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errorNumber ? "red" : "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={3.5}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Manager email
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          fullWidth
                          placeholder="manager@gmail.com"
                          type="email"
                          value={email}
                          onChange={handleEmailChange}
                          onBlur={handleEmailBlur}
                          error={!!error}
                          helperText={error}
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: error ? "red" : "black",
                              },
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: error ? "red" : "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  style={{ color: "black", margin: "10px" }}
                >
                  <Grid item xs={11} sm={11}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Address
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          fullWidth
                          placeholder="e.g.Address"
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          onChange={(e) => setAddress(e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  style={{ color: "black", margin: "10px" }}
                >
                  <Grid item xs={12} sm={4} md={3}>
                    <Stack direction="column">
                      <Typography
                        variant="p"
                        gutterBottom
                        style={{ color: "black" }}
                      >
                        Office type
                      </Typography>
                      <Select
                        value={type}
                        autoFocus
                        onChange={handleType}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={{
                          border: "1px solid black",
                          boxSizing: "border-box",
                          "& .MuiOutlinedInput-root": {
                            borderColor: "black !important",
                            "&:hover fieldset": {
                              borderColor: "black !important",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black !important",
                            },
                          },
                          color: "black",
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <span style={{ color: "gray" }}>
                                Select office type
                              </span>
                            );
                          }
                          return selected;
                        }}
                      >
                        {OfficeType.map((item) => (
                          <MenuItem value={item} key={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </Stack>
                  </Grid>
                  <Grid item xs={11} sm={7}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Details
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          fullWidth
                          placeholder="Rent,Contact date"
                          type="email"
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          onChange={(e) => setDetails(e.target.value)}
                          sx={{
                            marginTop: "5px",
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container sx={{ padding: "10px 0 20px 20px" }}>
                  <Grid item sx={11} className="messageFooter">
                    <Box className="response" onClick={SaveDate}>
                      Save
                    </Box>
                    <Box className="cancel" onClick={handleClose}>
                      Cancel
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Dialog>
          </React.Fragment>
        </ListItemText>
        <Divider />
        <ListItemText style={{ background: "white", margin: 0 }}>
          <ThemeProvider theme={getTheme()}>
            <Box
              sx={{
                overflowX: isBelow500px ? "auto" : "unset",
                maxWidth: "100%", // Ensure it doesn't exceed the parent container
              }}
            >
              <MUIDataTable
                title={
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: "1.5rem",
                      color: "#333",
                    }}
                  >
                    Business Location
                  </span>
                }
                data={businesslocation}
                columns={columns}
                options={options}
              />
            </Box>
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default BusinessSettings;
